import Grid from '@material-ui/core/Grid';
import { ThemeProvider } from '@material-ui/styles';
import React from 'react';
import { Redirect, RouteComponentProps, Switch } from 'react-router';
import { useHistory } from 'react-router-dom';
import { AuthorizedRoute } from './Components/Auth/AuthorizedRoute';
import { ErrorBoundary } from './Components/ErrorBoundary';
import { DeviceIcon, DeviceSummaryIcon } from './Components/Icons';
import { NavMenu, NavMenuItem } from './Components/Layout/NavMenu';
import { DeviceList } from './Devices/DeviceList';
import { DeviceSummary } from './DeviceSummary/DeviceSummary';
import { usePermissions } from './Hooks/usePermissions';
import { routeForDevices, routeForSummary } from './Routes';
import styles from './ServicesAustraliaFeature.module.scss';
import { ServicesAustraliaPermissions } from './ServicesAustraliaPermissions';
import { GlobalSnackbar } from './Shared/GlobalSnackbar';
import { body } from './Styles/Colours';
import { muiAuthorisationTheme } from './Styles/Theme';

export function ServicesAustraliaFeature(props: RouteComponentProps): React.ReactElement {
    return (
        <ErrorBoundary>
            <ThemeProvider theme={muiAuthorisationTheme}>
                <GlobalSnackbar>
                    <ServicesAustralia {...props} />
                </GlobalSnackbar>
            </ThemeProvider>
        </ErrorBoundary>
    );
}

function ServicesAustralia(props: RouteComponentProps) {
    const history = useHistory();

    return (
        <div className={styles.rootContents}>
            <Grid container spacing={0}>
                <Grid item>
                    <div className={styles.leftPanel}>
                        <NavMenu collapses>
                            <NavMenuItem
                                permissions={ServicesAustraliaPermissions.AdministrationGeneral}
                                icon={<DeviceSummaryIcon size='24' color={body} />}
                                title={'Summary'}
                                pathname={props.location.pathname}
                                location={routeForSummary}
                                referrerLocation={props.location}
                            />
                            <NavMenuItem
                                permissions={ServicesAustraliaPermissions.AdministrationGeneral}
                                onClick={() => history.push(routeForDevices, {})}
                                icon={<DeviceIcon size='24' color={body} />}
                                title={'Devices'}
                                pathname={props.location.pathname}
                                location={routeForDevices}
                                referrerLocation={props.location}
                            />
                        </NavMenu>
                    </div>
                </Grid>
                <Grid item xs className={styles.flex}>
                    <div className={styles.centerPanel}>
                        <Switch>
                            <AuthorizedRoute
                                path={routeForSummary}
                                component={DeviceSummary}
                                permission={ServicesAustraliaPermissions.AdministrationGeneral}
                            />
                            <AuthorizedRoute
                                path={routeForDevices}
                                component={DeviceList}
                                permission={ServicesAustraliaPermissions.AdministrationGeneral}
                            />
                            <Redirect to={routeForSummary} />
                        </Switch>
                    </div>
                </Grid>
            </Grid>
        </div>
    );
}
